declare namespace $ {

	type $mol_link__arg_shm_projects_goal_output_1 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_output['process_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_goal_output_2 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_output['process_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_goal_output_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_goal_output_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__click_shm_projects_goal_output_5 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_output['process_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_link__arg_shm_projects_goal_output_6 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_output['result_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_goal_output_7 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_output['result_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_goal_output_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_goal_output_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__click_shm_projects_goal_output_10 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_output['result_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_view__sub_shm_projects_goal_output_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_projects_goal_output extends $mol_page {
		process_arg( ): Record<string, any>
		process_current( ): boolean
		process_select( next?: any ): any
		Process( ): $mol_link
		result_arg( ): Record<string, any>
		result_current( ): boolean
		result_select( next?: any ): any
		Result( ): $mol_link
		Modes( ): $mol_view
		output_content( ): readonly(any)[]
		mode( next?: string ): string
		process( ): $shm_projects_goal_chat
		result( ): any
		title_content( ): readonly(any)[]
		body( ): ReturnType< $shm_projects_goal_output['output_content'] >
	}
	
}

//# sourceMappingURL=output.view.tree.d.ts.map